import { Certificate } from './Certificate'
import { Projects } from './Projects'
import { Social } from './Social'
import { Layout } from './Layout'
import { useContext, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { DataProvider } from '../../../store/ContextProvider'

export const HighLights = ({ candidate, fetchCandidateData }) => {
  const { currentUser } = useContext(DataProvider);
  const [certifications, setCetification] = useState([]);
  const [projects, setProjects] = useState([]);
  const [socialProfile, setSocialProfile] = useState([]);
  const navigate = useNavigate();


  // fetch the query:;

  const location = useLocation()
  const queryFetch = new URLSearchParams(location.search)
  const reverse = queryFetch.get('inverse') === "true"
  const previous = location.state?.from || '/account'
  const active = location.state?.active || 'Overview'



  useEffect(() => {
    if (candidate) {
      setCetification(candidate.certifications || []);
      setProjects(candidate.projects || []);
      setSocialProfile(candidate.socialProfiles || []);
    }
  }, [candidate]);

  useEffect(() => {
    fetchCandidateData()
  }, [])

  const handleNext = () => {
    const hasCert = certifications.length > 0;
    const hasProj = projects.length > 0;
    const hasSocial = socialProfile.length > 0;

    if (!hasCert && !hasProj && !hasSocial) {
      alert("Please add at least one: Certificate OR Project OR Social Profile");
      return;
    }
    if (reverse)
      navigate(previous, { state: { active } })

    else
      navigate(`/update-account/preferences?userId=${currentUser?._id}`);
  };

  return (
    <Layout candidate={candidate}>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full py-10 space-y-8 mb-20">
        <div className="w-full flex flex-col justify-center items-center gap-4">
          <div className="w-full">
            <Certificate candidate={candidate} />
          </div>

          <div className="w-full">
            <Projects candidate={candidate} />
          </div>

          <div className="w-full">
            <Social candidate={candidate} />
          </div>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4 w-full">
            <button onClick={() => navigate(`/update-account/experience?userId=${currentUser?._id}`)}
              type="button"
              className="w-full sm:w-auto border border-primary-500 text-primary-500 px-4 py-2 rounded-xl font-medium transition text-center"
            >
              Previous
            </button>

            <button
              type="button"
              onClick={handleNext}
              className="w-full sm:w-auto bg-[#2C25C4] text-white px-4 py-2 rounded-xl font-semibold shadow-md hover:opacity-90 transition text-center"
            >
              {reverse ? 'Update' : 'Next'}
            </button>
          </div>
        </div>
      </section>
    </Layout>
  );
};

